var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgKarcherLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 40,
    viewBox: "0 0 155 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_502_456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.56 27.6352H0V40H154.56V27.6352Z",
    fill: "#FFED00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.34 7.60433C60.34 9.59814 59.5518 10.1082 57.6198 10.1082H54.8686V5.30139H57.6507C59.6754 5.30139 60.34 5.82689 60.34 7.60433ZM67.2179 7.35703C67.2179 2.67388 63.9413 0.401855 57.7589 0.401855H48.2998V21.4529H54.8686V14.5131H57.5889L61.1592 21.4529H68.9026L63.5085 13.2612C65.8733 12.4266 67.2179 10.0927 67.2179 7.37249V7.35703Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.139 16.2597V13.0603H128.702V8.4544H120.139V5.64142H130.495L130.386 0.386398H113.57V21.4529H130.804L130.912 16.2597H120.139Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.614 21.4529V0.386398H103.076V8.1762H96.0742V0.386398H89.5054V21.4529H96.0742V13.5394H103.076V21.4529H109.614Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4606 0.865533C84.9459 0.355487 82.7821 0 80.7883 0C72.7048 0 69.1036 4.18856 69.1036 10.8346C69.1036 18.0216 72.9212 21.8393 80.2164 21.8393C82.3802 21.8393 84.7295 21.3292 86.507 20.541L85.8114 15.7187C84.4668 16.2442 82.8284 16.5842 81.0974 16.5842C77.0788 16.5842 76.0433 15.2087 76.0433 10.8501C76.0433 6.72334 77.0015 5.34776 81.0356 5.34776C82.9212 5.34776 84.4822 5.62597 85.8114 5.99691L86.4606 0.865533Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.997 7.60433C145.997 9.59814 145.209 10.1082 143.277 10.1082H140.526V5.30139H143.308C145.332 5.30139 145.997 5.82689 145.997 7.60433ZM152.875 7.35703C152.875 2.67388 149.598 0.401855 143.416 0.401855H133.957V21.4529H140.526V14.5131H143.246L146.816 21.4529H154.56L149.165 13.2612C151.53 12.4266 152.875 10.0927 152.875 7.37249V7.35703Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2287 13.0294H31.4065L33.1685 7.52705L33.8176 5.3323H33.8949L34.5131 7.52705L36.2287 13.0294ZM46.2287 21.4529L37.6816 0.386398H30.0773L21.7156 21.4374H28.7017L29.83 17.898H37.7434L38.8408 21.4374H46.2287V21.4529Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1716 0.386398H22.2875V4.85317H27.1716V0.386398Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5023 0.386398H40.6182V4.85317H45.5023V0.386398Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7558 0.386398L8.67079 8.28439H6.56878V0.386398H0V21.4529H6.56878V13.2303H8.59351L13.694 21.4529H21.7002L14.4359 10.3555L21.3138 0.386398H13.7558Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_502_456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 155,
    height: 40,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgKarcherLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Karcher_Logo.90d4fcdc98910b8335ae8622dd27d3bf.svg";